import {
  required,
  requiredIf,
  maxLength,
  email,
} from 'vuelidate/lib/validators';
import {
  isEmptyValues,
  isValidString,
} from 'styleguide-web/dist/lib/validators/validators';

import {
  isValidDate,
  isFutureDate,
} from 'styleguide-web/dist/lib/validators/date-validators';

import store from '@/store';

import IBAN from 'iban';

const formValidationRules = {
  request: {
    customer: {
      person: {
        accountNo: {

          validString(value) {
            if (!store.getters.isAirplusModule) {
              return true;
            }
            if (store.getters.isAirplusModule && typeof value != 'undefined' && value != null && value != '' && value != ' ' && value.substring(0, 2).toUpperCase() === 'CH') {
              return IBAN.isValid(value);
            }
            return false;
          },
        },
        costFlag: {
          required: requiredIf(function () {
            if (store.getters.isAirplusModule) {
              return true;
            }
          }),
          isValueTrue(value) {
            return isBooleanTrue(value);
          }
        },
        gender: {
          required,
        },
        firstName: {
          required,
          maxLength: maxLength(35),
          validString(value) {
            return !isEmptyValues(value) ? isValidString(value) : true;
          },
          ValidChars(value) {
            return !isEmptyValues(value) ? isValidChars(value) : true;
          }
        },
        name: {
          required,
          maxLength: maxLength(35),
          validString(value) {
            return !isEmptyValues(value) ? isValidString(value) : true;
          },
          ValidChars(value) {
            return !isEmptyValues(value) ? isValidChars(value) : true;
          }
        },
        firm: {
          maxLength: maxLength(35),
          validString(value) {
            return !isEmptyValues(value) ? isValidString(value) : true;
          },
        },
        birthDay: {
          required,
          validDate(value) {
            return !isEmptyValues(value) ? isValidDate(value) : true;
          },
          futureDate(value) {
            return !isEmptyValues(value) && isValidDate(value) ? !isFutureDate(value) : true;
          }
        },
        email: {
          required,
          email,
          maxLength: maxLength(50),
        },
      },
      contractId: {
        required,
        maxLength: maxLength(10),
        validString(value) {
          return !isEmptyValues(value) ? isValidString(value) : true;
        },
      },
      zipCodeCity: {
        required,
        maxLength: maxLength(100),
      }
    },
    streetName: {
      required,
      maxLength: maxLength(25),
      validString(value) {
        return !isEmptyValues(value) ? isValidString(value) : true;
      },
    },
    randomQuestionnaire: {
      $each: {
        selectedKey: {
          required,
        },
        selectedValue: {
          validString(value, item) {
            return isValidSelectedValue(item);
          },
        }
      }
    }
  }
};

const isValidSelectedValue = function (item) {
  var isValid = true;
  if (item.id == 3 && item.selectedKey == 'Y') {
    isValid = isValidCard(item.selectedValue);
  } else if (item.id == 5 && item.selectedKey == '') {
    isValid = isValidBranch(item.selectedKey, item.selectedValue);
  }
  console.log('isValidSelectedValue itemId : '+item.id +', isValid : ' + isValid);
  return isValid;
}
const isValidCard = function (selectedValue) {
  var isValid = true;
  if (selectedValue == null || selectedValue.length != 5 || isNaN(selectedValue)) {
    isValid = false;
  }
  console.log('isValidCard selectedValue : ' + selectedValue+', isValid : ' + isValid);
  return isValid;
}
const isValidBranch = function (selectedKey, selectedValue) {
  var isValid = true;
  if (selectedKey== null || selectedKey.length ==0 || selectedValue== null || selectedValue.length ==0) {
    isValid = false;
  }
  console.log('isValidBranch selectedKey : '+selectedKey+', selectedValue : ' + selectedValue+', isValid : ' + isValid);
  return isValid;
}
const isValidChars = function (value) {
  if (typeof store != "undefined") {
    for (var i = 0; i < value.length; i++) {
      if (store.state.allowedNameChars.indexOf(value.charAt(i)) == -1) {
        return false;
      }
    }
  }
  return true;
}
const isBooleanTrue = function (value) {
  if (value === true || !store.getters.isAirplusModule) {
    return true;
  }
  return false;
}

export default formValidationRules;
